__turbopack_context__.v({
  "columnLeft": "EddPanel-module__-U2OdG__columnLeft",
  "columnLeftLandscape": "EddPanel-module__-U2OdG__columnLeftLandscape",
  "columnRight": "EddPanel-module__-U2OdG__columnRight",
  "columnRightLandscape": "EddPanel-module__-U2OdG__columnRightLandscape",
  "container": "EddPanel-module__-U2OdG__container",
  "containerLandscape": "EddPanel-module__-U2OdG__containerLandscape",
  "eddColumn": "EddPanel-module__-U2OdG__eddColumn",
  "eddColumnReverse": "EddPanel-module__-U2OdG__eddColumnReverse",
});
